<template>
  <div>
    <div class="flex grid" :style="contentStyle">
      <div class="grid grid-flow-col gap-1">
        <span class="font-small block notification-title" :class="[`text-${item.dropdownCategory}`]">
          <feather-icon :icon="formatIconName(item)" :class="[`text-${item.dropdownCategory}`, 'stroke-current h-5 w-5']"></feather-icon>
          {{ item.dropdownTitle }}
        </span>
        <small class="pl-2 text-right whitespace-no-wrap">{{ elapsedTime(item.sentAt) }}</small>
      </div>
      <div class="item-data-container">
        <small class="break-all">
            <div v-html-safe="item.message(300)"></div>
        </small>
      </div>
      <div :hidden="!collapseContent" :style="faderElementStyle"></div>
    </div>

    <div @click.stop="expandCard" class="hover:text-primary cursor-pointer mt-1 w-full" >
      <div class="flex justify-center">
        <feather-icon
          class="mr-1"
          svgClasses="w-7 h-7"
          :icon="collapseContent? 'ChevronDownIcon' : 'ChevronUpIcon'"/>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationService from '@/services/api/NotificationService'

export default {

  components: {

  },
  props: {
    item: {
      type: Object,
      default: null
    },
  },
  data () {
    return {
      collapseContent: true,
      faderWidth: 0,
    }
  },
  watch: {
    windowWidth(width) {
      this.updateFaderWidth()
    },
  },
  computed: {
    contentStyle() {
      const collapsed = this.collapseContent
      const baseStyle = 'overflow-y: hidden; overflow-x: hidden;'
      return baseStyle + (collapsed ?
        'height: 52px;' : 'height: unset;')
    },
    faderElementStyle() {
      return `
        position: absolute;
        height: 30px;
        margin-top: 25px;
        width: ${this.faderWidth}px;
        background: linear-gradient(to top, rgba(255, 255, 255, 0.7) 0%,rgba(255, 255, 255, 0.5) 70%,rgba(255, 255, 255, 0) 100%);
        `
    },
  },
  methods: {
    formatIconName(notification) {
      try {
        if (!notification || !notification.dropdownIcon) {
          console.warn('Notification missing dropdownIcon:', notification)
          return 'BellIcon'
        }
        let icon = notification.dropdownIcon
        icon = (typeof icon === 'function') ? icon(notification) : icon

        if (!this.$utils || !this.$utils.format || !this.$utils.format.featherIcon || !this.$utils.format.featherIcon.fromNotify) {
          console.error('VueUtils not properly initialized', this.$utils)
          return 'BellIcon'
        }

        return this.$utils.format.featherIcon.fromNotify(icon)
      } catch (error) {
        console.error('Error formatting icon name:', error, notification)
        return 'BellIcon'
      }
    },
    elapsedTime (startTime) {
      const x        = new Date(startTime)
      const now      = new Date()
      let timeDiff = now - x
      timeDiff    /= 1000

      const seconds = Math.round(timeDiff)
      timeDiff    = Math.floor(timeDiff / 60)

      const minutes = Math.round(timeDiff % 60)
      timeDiff    = Math.floor(timeDiff / 60)

      const hours   = Math.round(timeDiff % 24)
      timeDiff    = Math.floor(timeDiff / 24)

      const days    = Math.round(timeDiff % 365)
      timeDiff    = Math.floor(timeDiff / 365)

      const years   = timeDiff

      if (years > 0) {
        return `${years + (years > 1 ? ' anos ' : ' Ano ')}atrás`
      } else if (days > 0) {
        return `${days + (days > 1 ? ' dias ' : ' dia ')}atrás`
      } else if (hours > 0) {
        return `${hours + (hours > 1 ? ' hrs ' : ' hora ')}atrás`
      } else if (minutes > 0) {
        return `${minutes + (minutes > 1 ? ' mins ' : ' min ')}atrás`
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? 's atrás' : 'agora')
      }

      return 'Just Now'
    },
    //
    expandCard() {
      this.collapseContent = !this.collapseContent
    },
    itemDataContainerWidth() {
      return this.$utils.DOM.measure.elementWidth('.item-data-container')
    },
    updateFaderWidth() {
      this.faderWidth = this.itemDataContainerWidth()
    },
  },
  mounted() {
    this.updateFaderWidth()
  }
}

</script>
<style lang="scss" scoped>
  @import 'src/assets/scss/vuexy/_variables.scss';
  .item-data-container{
    &:hover{
      background: linear-gradient(to top, rgba($theme-background, 0.7) 0%,rgba($theme-background, 0.5) 70%,rgba($theme-background, 0) 100%);
    }
  }
</style>

